import {
  Directive,
  Output,
  ElementRef,
  HostListener,
  EventEmitter,
} from '@angular/core';

@Directive({
  selector: '[lfxClickOutside]',
})
export class ClickOutsideDirective {
  @Output() lfxClickOutside = new EventEmitter();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event.target'])
  onClick(targetElement: HTMLElement) {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);

    if (!clickedInside) {
      this.lfxClickOutside.emit('');
    }
  }
}
